function Home({ className }) {
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.99609 0.75C9.29784 0.75 9.55444 0.835889 9.79004 1.01465V1.01562L16.7139 6.31543L16.7227 6.32227C16.8834 6.44133 17.0102 6.59249 17.1055 6.78613L17.1074 6.78906C17.2032 6.98223 17.25 7.18311 17.25 7.40039V18.7002C17.25 18.8411 17.2065 18.9581 17.082 19.084C16.9577 19.2097 16.8455 19.25 16.7139 19.25H12.3633C12.2852 19.25 12.2365 19.2347 12.1953 19.2051L12.1562 19.1709C12.1036 19.117 12.0742 19.0595 12.0742 18.9492V12.75C12.0742 12.2666 11.9048 11.8248 11.5596 11.4756C11.2136 11.1258 10.7724 10.9503 10.2861 10.9502H7.71387C7.2288 10.9503 6.78847 11.1246 6.44336 11.4736C6.09669 11.8226 5.9258 12.2655 5.92578 12.75V18.9512C5.92574 19.062 5.89601 19.1181 5.84375 19.1709C5.7919 19.2233 5.74021 19.25 5.6377 19.25H1.28613C1.15448 19.25 1.04234 19.2097 0.917969 19.084C0.793478 18.9581 0.750033 18.8411 0.75 18.7002V7.40039C0.750047 7.18311 0.796836 6.98223 0.892578 6.78906C0.988989 6.59467 1.11724 6.44296 1.27832 6.32324L1.28613 6.31641L8.20996 1.01562L8.21289 1.01367C8.44184 0.83697 8.69375 0.750009 8.99609 0.75Z'
        stroke='#949494'
        stroke-width='1.5'
      />
    </svg>
  );
}

function ActiveHome() {
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 17.765V7.03068C0 6.71453 0.0737142 6.41525 0.221143 6.13286C0.368571 5.85046 0.571714 5.61787 0.830571 5.4351L7.75414 0.398896C8.11671 0.132966 8.53071 0 8.99614 0C9.46157 0 9.87814 0.132966 10.2459 0.398896L17.1694 5.43386C17.4291 5.61664 17.6323 5.84964 17.7789 6.13286C17.9263 6.41525 18 6.71453 18 7.03068V17.765C18 18.096 17.8719 18.3846 17.6156 18.6307C17.3593 18.8769 17.0589 19 16.7143 19H12.3634C12.0686 19 11.8217 18.9045 11.6229 18.7135C11.424 18.5217 11.3246 18.2845 11.3246 18.0021V12.1126C11.3246 11.8302 11.2251 11.5935 11.0263 11.4025C10.8266 11.2106 10.5797 11.1147 10.2857 11.1147H7.71429C7.42029 11.1147 7.17386 11.2106 6.975 11.4025C6.77529 11.5935 6.67543 11.8302 6.67543 12.1126V18.0034C6.67543 18.2858 6.576 18.5225 6.37714 18.7135C6.17829 18.9045 5.93186 19 5.63786 19H1.28571C0.941143 19 0.640714 18.8769 0.384428 18.6307C0.128143 18.3846 0 18.096 0 17.765Z'
        fill='#3A3A3A'
      />
    </svg>
  );
}

export { Home, ActiveHome };
